import React, {useContext, useEffect} from 'react'
import farmerContext from '../../../context/farmer/farmerContext'
import ManageFarmTableRow from './ManageFarmTableRow'
import {useAlert} from "react-alert";


const ManageFarmTable = () => {
    const alert = useAlert()
    const FarmerContext = useContext(farmerContext);
    const {getFarms, farmer, clearPageLoading, clearAlert} = FarmerContext;
    const {farms, page_loading} = farmer;


    useEffect(() => {

        //Get all farmers farms when the component mounts
        if (farms.length === 0) {
            getFarms().then(res => {
                clearPageLoading();
            });
        } else {
            clearPageLoading();
        }
        if (farmer.message.msg !== "") {
            alert.show(
                farmer.message.msg, farmer.message.msg_options
            )
            clearAlert()
        }
        //eslint-disable-next-line
    }, [page_loading, farms]);
    return (
        <div className="content-wrapper">
            <div className="container-fluid">
                <h3 className="make-bold">Manage Farm</h3>
                <p>Manage your farm by Editing or deleting.</p>
                {/* <!--Start Dashboard Content--> */}

                <div className="dashboard-inner-view">
                    <div className="row mt-3">
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Farm Name</th>
                                        <th scope="col">Farm Type</th>
                                        <th scope="col">State</th>
                                        <th scope="col">LGA</th>
                                        <th scope="col">Address</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                    </thead>
                                    {/*loading indicator*/}
                                    <tbody>

                                    {
                                        farms.length > 0 ? farms.map((farm, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <ManageFarmTableRow farm={farm}/>
                                            </tr>
                                        )) : <tr>You don't have any farm yet...</tr>
                                    }

                                    </tbody>
                                </table>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className={page_loading + " justify-content-center"}>
                                            <div className="spinner-grow text-success" role="status"
                                                 style={{width: "6rem", height: "6rem"}}>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!--End Dashboard Content--> */}

            </div>
            {/* <!-- End container-fluid--> */}

        </div>
//   <!--End content-wrapper-->     

    )
}

export default ManageFarmTable
